<template>
  <v-container fluid>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <v-row>
      <v-col>
        <validation-observer ref="orderImportValidator">
          <v-form>
            <v-card class="layout-custom-import rounded-card" elevation="1">
              <v-card-title>EDI情報紐付けのインポート</v-card-title>
              <v-card-subtitle>
                <p>ここでは指定する形式のCSVでインポートすることでEDI申請を「EDI利用可能」更新することができます。</p>
              </v-card-subtitle>
              <v-divider />
              <v-card-text>
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{ required: true, mimes: 'text/csv', megaFileSizeChecker: 10, fileChecker: true }"
                  class="requiredMark"
                  name="CSVファイル"
                >
                  <v-file-input
                    v-model="forms.file"
                    :error-messages="errors"
                    :show-size="1000"
                    accept="text/csv"
                    dense
                    hide-details="auto"
                    hint="ファイルサイズ10MBまで。最大100件まで。"
                    label="CSVファイル"
                    outlined
                    persistent-hint
                    persistent-placeholder
                    required
                  />
                </validation-provider>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="primary"
                  @click="uploadButtonClickEvent"
                >
                  アップロード
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </validation-observer>
      </v-col>
    </v-row>
    <v-row style="margin-bottom: 120px;">
      <v-col>
        <v-card class="rounded-card" elevation="1">
          <v-card-title>
            EDI情報紐付け一覧
          </v-card-title>
          <v-divider />
          <v-card-text>
            <v-data-table
              v-model="selectedItems"
              :headers="tableHeaders"
              :items="importedData"
              :items-per-page="-1"
              item-key="selection_key"
              disable-pagination
              disable-sort
              hide-default-footer
              show-select
              dense
              @click:row="toggleRowSelection"
            >
              <template v-slot:[`item.subscriber_info`]="{ item }">
                <div>{{ item.subscriber_number }}</div>
                <div>{{ item.edi_usage_key }}</div>
              </template>
              <template v-slot:[`item.tenant_info`]="{ item }">
                <div>{{ item.tenant_code }}</div>
                <div>{{ item.tenant_name }}</div>
              </template>
              <template v-slot:[`item.jwnet_info`]="{ item }">
                <div>{{ item.jwnet_name }}</div>
                <div>{{ item.emission_name }}</div>
              </template>
              <template v-slot:[`item.address_info`]="{ item }">
                <div class="line-clamp one-clamp">{{ item.address }}</div>
                <div>{{ item.code }}</div>
              </template>
              <template v-slot:[`item.status_info`]="{ item }">
                <div>{{ item.edi_request_status }}</div>
                <div>{{ item.edi_request_at }}</div>
              </template>
              <template v-slot:[`item.person_in_charge`]="{ item }">
                <div>{{ item.jwnet_pricing_type | jwnet_pricing_type_label}}</div>
                <div>{{ item.person_in_charge }}</div>
              </template>
              <template v-slot:[`item.emission_select`]="{ item }">
                <v-btn
                  small
                  color="primary"
                  :disabled="!Array.isArray(item.emission_request_ids) && (item.tenant_code !== '不明')"
                  @click.stop="openEmissionSelectDialog(item)"
                >
                  選択
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- 固定フッター -->
    <v-footer fixed class="mb-8" color="white" width="100%" style="overflow-x: auto;">
      <v-card flat width="100%">
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            class="mr-3"
            :disabled="selectedItems.length <= 0"
            @click="registerButtonClickEvent"
          >
            登録
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-footer>
    <!-- /固定フッター -->
    
    <!-- 排出事業者選択ダイアログ -->
    <emission-select-dialog
      v-model="emissionSelectDialog.show"
      :emission-request-ids="emissionSelectDialog.emissionRequestIds"
      :current-item="emissionSelectDialog.currentItem"
      @selected="onEmissionSelected"
    />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import EmissionSelectDialog from './EmissionSelectDialog.vue'

export default {
  name: 'EdiRequestCsvImport',
  components: {
    EmissionSelectDialog,
  },
  mixins: [],
  props: {},
  data() {
    return {
      forms: {
        file: null,
      },
      reloadComponent: null,
      importedData: [],
      selectedItems: [],
      emissionSelectDialog: {
        show: false,
        emissionRequestIds: [],
      },
      tableHeaders: [
        { value: 'subscriber_info', text: '加入者番号\r\nEDI利用確認キー' },
        { value: 'edi_business_name', text: 'EDI事業者名'},
        { value: 'tenant_info', text: 'テナントコード\r\nテナント名' },
        { value: 'jwnet_info', text: 'JWNET登録名\r\n排出事業者名' },
        { value: 'address_info', text: '住所\r\n事業者コード' },
        { value: 'status_info', text: 'EDI申込ステータス\r\nEDI申込メール送信日時' },
        { value: 'person_in_charge', text: '料金区分\r\n担当者' },
        { value: 'emission_select', text: '排出事業者選択' },
      ],
    }
  },
  computed: {
    breadcrumbs() {
      return [
        { text: 'EDI申込管理一覧', disabled: false, to: '/admin/edi_requests', exact: true },
        { text: this.importTitle, disabled: true, to: '' },
      ]
    }
  },
  watch: {},
  created() {
  },
  methods: {
    ...mapActions('AdminSettingEdiRequest', {
      upload: 'create',
      register: 'register',
    }),
    uploadButtonClickEvent () {
      let $self = this
      this.$refs.orderImportValidator.validate().then((result) =>{
        if(result){
          $self.sendRegistrationInformation()
        }
      })
    },

    sendRegistrationInformation(){
      const params = new FormData()
      params.append('file', this.forms.file)
      params.append('format', 'csv')
      /**
       * @typedef content { Object }
       * @property has_error { Boolean }
       * @property errors { Array }
       */
      this.upload({params: params}).then((response) => {
        this.reloadComponent = this.$dayjs().unix()
        // インポートされたデータがあれば一覧に表示
        if (response) {
          this.importedData = response.map(item => this.buildImportItem(item))
          this.selectedItems = []
        }
        this.resetForm()
      })
    },
    resetForm () {
      this.$nextTick(() => this.$refs.orderImportValidator.reset())
      Object.assign(this.$data.forms, this.$options.data().forms)
    },
    toggleRowSelection (item) {
      const index = this.selectedItems.findIndex(row => row === item)
      if (index > -1) {
        // 既に選択されている場合は削除
        this.selectedItems.splice(index, 1)
      } else {
        // 選択されていない場合は追加
        this.selectedItems.push(item)
      }
    },
    buildSelectionKey (item) {
      return [item.subscriber_number, item.edi_usage_key].join('__')
    },
    buildImportItem (item) {
      return {
        ...item,
        selection_key: this.buildSelectionKey(item),
      }
    },
    registerButtonClickEvent () {
      if (this.selectedItems.length === 0) {
        return
      }
      
      // emission_idsが配列でない場合のみ対象とする
      const validItems = this.selectedItems.filter(item => {
        return !Array.isArray(item.emission_request_ids) && item.emission_request_ids != null
      })
      
      if (validItems.length === 0) {
        this.$store.dispatch('snackbar/showError', {
          message: '排出事業者が1つ選択されている項目がありません'
        })
        return
      }

      
      // 登録データを作成
      const registrationData = validItems.map(item => ({
        subscriber_number: item.subscriber_number,
        edi_usage_key: item.edi_usage_key,
        edi_business_name: item.edi_business_name,
        jwnet_name: item.jwnet_name,
        emission_request_id: item.emission_request_ids,
        jwnet_price_plan: item.jwnet_pricing_type,
      }))
      
      const params = {
        items: registrationData
      }
      
      // 登録処理を実行
      this.register({ params }).then(() => {
        // 成功時はEDI申込管理一覧に遷移
        this.$router.push('/admin/edi_requests')
      })
    },
    openEmissionSelectDialog (item) {
      this.emissionSelectDialog.emissionRequestIds = item.emission_request_ids
      this.emissionSelectDialog.currentItem = item
      this.emissionSelectDialog.show = true
    },
    onEmissionSelected ({ item, emission_request }) {
      // 選択された排出事業者の情報で一覧行を更新
      const selectionKey = this.buildSelectionKey(item)
      const index = this.importedData.findIndex(row => row.selection_key === selectionKey)
      if (index > -1) {
        this.$set(this.importedData[index], 'emission_request_ids', emission_request.emission_request_id)
        this.$set(this.importedData[index], 'tenant_code', emission_request.tenant_code)
        this.$set(this.importedData[index], 'tenant_name', emission_request.tenant_name)
        this.$set(this.importedData[index], 'jwnet_name', emission_request.jwnet_name)
        this.$set(this.importedData[index], 'emission_name', emission_request.emission_name)
        this.$set(this.importedData[index], 'address', emission_request.address)
        this.$set(this.importedData[index], 'code', emission_request.code)
        this.$set(this.importedData[index], 'jwnet_pricing_type', emission_request.jwnet_pricing_type)
        this.$set(this.importedData[index], 'edi_request_status', emission_request.edi_status_name)
        this.$set(this.importedData[index], 'edi_request_at', emission_request.edi_request_at)
        this.$set(this.importedData[index], 'person_in_charge', emission_request.person_in_charge)
      }
      // selectedItemsも更新
      const selectedIndex = this.selectedItems.findIndex(row => row.selection_key === selectionKey)
      if (selectedIndex > -1) {
        this.$set(this.selectedItems[selectedIndex], 'emission_request_ids', emission_request.emission_request_id)
        this.$set(this.selectedItems[selectedIndex], 'tenant_code', emission_request.tenant_code)
        this.$set(this.selectedItems[selectedIndex], 'tenant_name', emission_request.tenant_name)
        this.$set(this.selectedItems[selectedIndex], 'jwnet_name', emission_request.jwnet_name)
        this.$set(this.selectedItems[selectedIndex], 'emission_name', emission_request.emission_name)
        this.$set(this.selectedItems[selectedIndex], 'address', emission_request.address)
        this.$set(this.selectedItems[selectedIndex], 'code', emission_request.code)
        this.$set(this.selectedItems[selectedIndex], 'jwnet_pricing_type', emission_request.jwnet_pricing_type)
        this.$set(this.selectedItems[selectedIndex], 'edi_request_status', emission_request.edi_status_name)
        this.$set(this.selectedItems[selectedIndex], 'edi_request_at', emission_request.edi_request_at)
        this.$set(this.selectedItems[selectedIndex], 'person_in_charge', emission_request.person_in_charge)
      }
    },
  },
}
</script>

<style scoped lang="scss">

</style>
